import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  sortBy: "",
};

const jobSortingSlice = createSlice({
  name: "jobSorting",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setSort: (state, action) => {
      state.sortBy = action.payload;
    },
  },
});

export const { setSearch, setSort } = jobSortingSlice.actions;

export default jobSortingSlice.reducer;
